/**
 * Slider
 */
export default class Slider {
	constructor($element) {
		this.$element = $element;
		this.options = {};
	}

	initialize(options) {
		let _self = this;
		let mergedOptions = $.extend(true, options, this.$element.data('options'));

		if(mergedOptions['loop'] && this.$element.find('> *').length < 2) {
			mergedOptions['loop'] = false;
		}

		if(mergedOptions['nav']) {
			mergedOptions['navText'] = [
				'<i class="fa fa-angle-left"></i>',
				'<i class="fa fa-angle-right"></i>'
			];
		}

		console.log(mergedOptions);

		this.$element.on('initialized.owl.carousel', function() {
			_self.$element.css('opacity', 1);
		});

		this.$element.owlCarousel(mergedOptions);
	}
}